import { render, staticRenderFns } from "./DcContribution.vue?vue&type=template&id=ef481ee0&scoped=true&"
import script from "./DcContribution.vue?vue&type=script&lang=js&"
export * from "./DcContribution.vue?vue&type=script&lang=js&"
import style0 from "bootstrap/dist/css/bootstrap.min.css?vue&type=style&index=0&id=ef481ee0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef481ee0",
  null
  
)

export default component.exports